import React from 'react';
import { skillsBand } from '../data/content';
import { SectionHeading } from './SectionHeading';

/** Trail-marker colors for the 10 skills (decorative only) */
const markers = ['#A3E635', '#FFB82E', '#F26B1D', '#1E88E5', '#22A55B', '#00A6D6', '#FFD166', '#7BC67E', '#FF8FA3', '#FFFFFF'];

/** New in this landing: one skill per complete meeting (as trail markers) + the 2 age levels every meeting adapts to */
export function SkillsBand() {
  return <section aria-labelledby="skills-title" className="bg-ink py-12 md:py-16" data-id="element-232" data-mp="2yjamirsf61b0">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-233" data-mp="33kzwe43wo8xi">
        <SectionHeading id="skills-title" tone="dark" eyebrow={skillsBand.eyebrow} title={skillsBand.title} sub={skillsBand.sub} data-id="element-234" data-mp="38j1hsvot0kc5" />

        <ol className="mx-auto mt-8 grid max-w-[980px] grid-cols-2 gap-2.5 sm:grid-cols-3 md:mt-10 md:grid-cols-5 md:gap-3" data-id="element-235" data-mp="3db1mf1ftk1f2">
          {skillsBand.skills.map((s, i) => <li key={s.n} className="flex items-center gap-3 rounded-xl bg-white/[0.06] px-3.5 py-3 ring-1 ring-white/10" data-id="element-236" data-mp="2kt74ye4hivrw" data-mpi={i}>
              <span aria-hidden="true" className="h-7 w-7 shrink-0 rotate-45 rounded-[5px]" style={{
            background: markers[i % markers.length],
            boxShadow: 'inset 0 -2px 0 rgba(0,0,0,0.2)'
          }} data-id="element-237" data-mp="3p7cv1qztvenz" />
              <div className="min-w-0" data-id="element-238" data-mp="3bh9glm76wp93">
                <p className="font-display text-[11px] font-extrabold tracking-[0.12em] text-sun" data-id="element-239" data-mp="3bghsewfx9tsu">MEETING {s.n}</p>
                <p className="mt-0.5 font-display text-[16px] font-black uppercase leading-tight tracking-tight text-white" data-id="element-240" data-mp="36jrcqa81507y">{s.skill}</p>
              </div>
            </li>)}
        </ol>

        <h3 className="mt-10 text-center font-display text-[13px] font-black tracking-[0.14em] text-sun" data-id="element-241" data-mp="2wkilhp4jtzpa">{skillsBand.agesTitle}</h3>
        <ul className="mx-auto mt-4 grid max-w-[760px] gap-3 md:grid-cols-2" data-id="element-242" data-mp="2skrm4x0yib95">
          {skillsBand.ages.map(a => <li key={a.age} className="rounded-xl border border-white/10 bg-brand p-5" data-id="element-243" data-mp="qqinkvu6c0ug">
              <p className="inline-block rounded-md bg-coral px-2 py-1 font-display text-[12px] font-black tracking-[0.1em] text-white" data-id="element-244" data-mp="2ka13v36g8lon">{a.age}</p>
              <p className="mt-3 text-[15px] leading-relaxed text-white/85" data-id="element-245" data-mp="2p19ajrge9sy4">{a.text}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}